import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { withTranslation } from 'react-i18next';

function CancelMaintenanceDialog({ t, open, handleClose, onConfirm }) {

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="cancel-maintenance-dialog-title"
      aria-describedby="cancel-maintenance-dialog-description"
    >
      <DialogTitle id="cancel-maintenance-dialog-title">{t('Cancel maintenance')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="cancel-maintenance-dialog-description">
          {t('Are you sure you want to cancel this work order?')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('Back')}
        </Button>
        <Button onClick={handleConfirm} color="error">
          {t('Cancel maintenance')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withTranslation()(CancelMaintenanceDialog);